import React from 'react';
import { LEARNING_VALUES } from 'constants/learningExperiences';
import ElementBase from '../base';
import Header from './Header';
import Body from './Body';

const learningExperienceInitialValue = (
  displayFullWidth,
  popout,
  draftRegistration,
) => {
  if (popout) {
    return LEARNING_VALUES.NEW_WINDOW;
  }
  if (displayFullWidth || draftRegistration === null) {
    return LEARNING_VALUES.FULL_WIDTH;
  }
  return LEARNING_VALUES.IN_LINE;
};

const Elearning = props => {
  const {
    content: {
      display_full_width: displayFullWidthScormValue,
      popout: popoutScormValue,
      finish: finishScormValue,
      id: scormId,
      restart: restartScormValue,
      has_unpublished_file: hasUnpublishedFile,
      published_course_version: publishedVersion,
      draft_registration: draftRegistration,
      current_draft_display_title: currentDraftDisplayTitle,
    },
    handleUpdate,
  } = props;

  const displayFullWidth = draftRegistration
    ? draftRegistration.display_full_width
    : displayFullWidthScormValue;

  const popout = draftRegistration
    ? draftRegistration.popout
    : popoutScormValue;

  const finish = draftRegistration
    ? draftRegistration.finish
    : finishScormValue;

  const restart = draftRegistration
    ? draftRegistration.restart
    : restartScormValue;

  return (
    <div className="EditorElement-content">
      <Header />
      <Body
        learningExperienceInitialValue={learningExperienceInitialValue(
          displayFullWidth,
          popout,
          draftRegistration,
        )}
        finish={finish}
        scormId={scormId}
        handleUpdate={handleUpdate}
        restartVal={restart}
        canUploadFile={!hasUnpublishedFile}
        publishedVersion={publishedVersion}
        filename={currentDraftDisplayTitle}
      />
    </div>
  );
};

export default ElementBase(Elearning);
